import React from 'react';
import {DrawerEdge} from 'components/customer/Job/store/jobApi';
import LabelValue from 'components/customer/PDF/components/LabelValue';

const DrawerEdges = ({drawerEdges}: {drawerEdges: DrawerEdge[]}) => {
    return (
        <>
            <div className="hr mt-5" />
            <section>
                <div className="font-sm mt-5">
                    <strong>DOOR DRAWER EDGING:</strong>
                </div>
                {drawerEdges.map((edge, i) => {
                    return (
                        <div
                            // eslint-disable-next-line react/no-array-index-key -- no unique key
                            key={`drawer-${i}`}
                            className="flex-col mt-5">
                            <LabelValue
                                inline
                                label={`DRAWER ${i + 1}`}
                                value={`Top: ${edge.top}; Bottom: ${edge.bottom}; Left: ${edge.left}; Right: ${edge.right}`}
                            />
                        </div>
                    );
                })}
            </section>
        </>
    );
};

export default DrawerEdges;
